export function pushToDataLayer(data: object) {
  // @ts-ignore
  window.dataLayer = window.dataLayer || []
  // @ts-ignore
  window.dataLayer.push(data)
}
